import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import VerifyReceipt from "./views/VerifyReceipt.vue";
import VerifyLicence from "./views/VerifyLicence.vue";
import SelfAssessment from "./views/SelfAssessment.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/tcc/:id",
      name: "verify-tcc-by-route",
      component: Home,
    },
    {
      path: "/verify-receipt",
      name: "verify-receipt",
      component: VerifyReceipt,
    },
    {
      path: "/verify-licence/:id?",
      name: "verify-licence",
      component: VerifyLicence,
    },
    {
      path: "/verify-receipt/:id",
      name: "verify-receipt-by-route",
      component: VerifyReceipt,
    },
    {
      path: "/assessment",
      name: "assessment",
      component: SelfAssessment,
    },
  ],
});
